<template>
    <div class="c-app">
        <HvvSidebar/>
        <CWrapper>
            <HvvHeader />
            <div class="c-body">
                <main class="c-main mr-3 mb-3 pr-3">
                    <CContainer fluid class="mx-3 my-2">
                        <transition name="fade" mode="out-in">
                        <router-view :key="$route.path"></router-view>
                        </transition>
                    </CContainer>
                </main>
            </div>
            <HvvFooter />
        </CWrapper>
    </div>
</template>

<script>
    import HvvSidebar from './HvvSidebar.vue';
    import HvvHeader from './HvvHeader.vue';
    import HvvFooter from './HvvFooter.vue';

    export default {
        name: 'HvvContainer',
        components: {
            HvvSidebar,
            HvvHeader,
            HvvFooter,
        }
    }
</script>